
// This is an auto generated file - do not edit!
// Swagger path: /api/Import/{typeCode}/template

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    CsvFileFormat
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ImportTypecodeTemplateApiService extends BaseApiService {
    
    get(typeCode: string, fileFormat?: CsvFileFormat, options = {}): Observable<any> {
        let params = new HttpParams();
        if(fileFormat !== undefined) {
            params = params.append('fileFormat', fileFormat);
        }

        options = {
            ...options,
            observe: 'response',
            responseType: 'blob' as 'json',
        };

        return this._get<any>(
            `/Import/${typeCode}/template`, {
                ...options,
                params,
            }
        );
    }
}
